import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { EntityPeppolIDContainerModel } from '../../../../../../models/aggregates/e-invoice/peppol/bl_fi_entity_peppol_id.model';

@Injectable({
  providedIn: 'root'
})
export class EntityPeppolIdService extends BaseApiTemplateService<EntityPeppolIDContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/ppl/entity-peppol-ids/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/ppl/entity-peppol-ids/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/ppl/entity-peppol-ids/backoffice-ep'
    this.httpClient = http;
  }
}
